import { Box, styled } from "@mui/material";

export const StyledDashBoardPieChart = styled(Box)(({ theme }) => ({
  width: "95%",
  height: "95%",
  position: "relative",
  ".chartData": {
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    h3: {
      textAlign: "center",
      color: theme.contrast.dark,
      fontWeight: "bold",
    },
    h2: {
      textAlign: "center",
      color: theme.color.main,
    },
  },
  [`@media screen and (max-width: ${theme.breakpoints.values.wide}px)`]: {
    ".chartData": {
      h3: {
        fontSize: "1.3rem",
      },
      h2: {
        fontSize: "2rem",
      },
    },
  },
}));
